import React from 'react';
import { navigate } from 'gatsby'
import { getForm } from '../../helpers';
import useFormReducer from '../../hooks/useFormReducer'
import {submitForm} from '../../api';
import SinglePageForm from './SinglePageForm';
import MultiPageForm from './MultiPageForm';

const Form = ({ allFormData, id, successCallback, errorCallback }) => {
    const [formState, dispatch] = useFormReducer();

    const { formId, title, apiURL, formFields, button, confirmations, pagination } = getForm(allFormData, id)

    const formSubmit = async e => {
        dispatch({
            type: 'toggleSubmitting'
        })

        e.preventDefault()

        submitForm({id, formState})
            .then(json => {
                if (!json.is_valid) {
                    dispatch({
                        type: 'toggleSubmitting'
                    })

                    dispatch({
                        type: 'setMessage',
                        key: 'error',
                        value: JSON.stringify(json)
                    })

                    return
                }

                if (json.confirmation_redirect) {
                    const redirectPath = new URL(json.confirmation_redirect).pathname
                    navigate(redirectPath)
                } else {
                    dispatch({
                        type: 'toggleSubmitting'
                    })

                    dispatch({
                        type: 'setMessage',
                        key: 'success',
                        value: json.confirmation_message
                    })
                }
            })
            .catch(error => {
                dispatch({
                    type: 'toggleSubmitting'
                })

                dispatch({
                    type: 'setMessage',
                    key: 'error',
                    value:'Something went wrong.'
                })

                console.error(error)
            })
    }

    const formPages = pagination?.pages?.map((page, i) => {
        const pageFields = formFields.filter(field => field.type !== 'page' && field.pageNumber === i + 1)

        return {
            id: i,
            title: page,
            fields: pageFields
        }
    })

    if (formPages) {
        return (
            <MultiPageForm
                formPages={formPages}
                formState={formState}
                formSubmit={formSubmit}
                dispatch={dispatch}
                submitButton={button}
            />
        )
    } else {
        return (
            <SinglePageForm
                formFields={formFields}
                formState={formState}
                formSubmit={formSubmit}
                dispatch={dispatch}
                submitButton={button}
            />
        )
    }
}

export default Form;